import { makeStyles } from "tss-react/mui"
import { spacing } from "../../assets/spacing"

export const useStyles = makeStyles()((theme) => ({
    ...spacing(theme),
}))
